import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'squareEvents',
  },
  itemDesign: {},
  buttonDesign: {},
  containerDesign: {},
  activeItem: {},
};

export const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    eventStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, buttonDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};
      state.buttonDesign = buttonDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
      state.blockDesign = {
        view: blockDesign.view ?? 'squareEvents',
      };
    },
    eventClear: () => initialState,

    eventUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    eventUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    eventUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    eventUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
    eventUpdateItemDesign: (state, action) => {
      state.itemDesign = action.payload;
    },
    eventUpdateActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
  },
});

export const { eventStore, eventClear, eventUpdateIsLoading, eventUpdateIsActive, eventUpdateBlockContent, eventUpdateBlockDesign, eventUpdateItemDesign, eventUpdateActiveItem } =
  eventSlice.actions;

export const selectEventIsLoading = (state) => state.event.isLoading;

export const selectEventId = (state) => state.event.id;
export const selectEventUID = (state) => state.event.uid;
export const selectEventSID = (state) => state.event.sid;

export const selectEventBlockContent = (state) => state.event.blockContent;
export const selectEventBlockDesign = (state) => state.event.blockDesign;
export const selectEventSortItems = createSelector([selectEventBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectEventItemDesign = (state) => state.event.itemDesign;
export const selectEventButtonDesign = (state) => state.event.buttonDesign;
export const selectEventContainerDesign = (state) => state.event.containerDesign;

export const selectEventActiveItem = (state) => state.event.activeItem;

export default eventSlice.reducer;
